import { GroupByMode, ID, User } from '@griply/types';

export const getInboxCustomOrderByGrouping = (
  user: User | undefined | null,
  groupBy: GroupByMode | null | undefined,
): { [GroupByMode.None]: ID[] } | Record<ID, ID[]> => {
  const inboxOrder = user?.settings?.customTaskOrder?.inbox;

  if (!groupBy || groupBy === GroupByMode.None) {
    return {
      [GroupByMode.None]: inboxOrder?.[GroupByMode.None] ?? [],
    };
  }

  return inboxOrder?.[groupBy] ?? {};
};
